import React, { useState, useEffect } from "react";
import axios from "axios";
import Notification from "../Notification";
import Adminnavbar from "./Adminnavbar";
import Adminpagination from "./Adminpagination";
import Footer from "../footer";
import Scrolltotopbtn from "../Scrolltotopbutton";
import Select from "react-select";
import { firstImage } from "../../parseImages";
import { formatPrice } from "../../convertPrice";

export default function Sales() {
  const [pageSize, setPageSize] = useState(15);
  const [currentPage, setCurrentPage] = useState(1);
  const [salesProducts, setSalesProducts] = useState([]);
  const [users, setUsers] = useState([]);
  // eslint-disable-next-line
  const [viewRowIndex, setViewRowIndex] = useState(null);
  const [notification, setNotification] = useState(null);
  const [selectedSeller, setSelectedSeller] = useState("All Sales");

  useEffect(() => {
    setCurrentPage(1);
    setViewRowIndex(null);
  }, [pageSize]);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_HOST}${process.env.REACT_APP_PORT}/shipmentjoin`
      )
      .then((res) => {
        if (res.data !== "Fail" && res.data !== "Error") {
          setSalesProducts(res.data);
        }
      })
      .catch((error) => {
        console.error("Sales: request failed:", error);
      });
    axios
      .get(
        `${process.env.REACT_APP_HOST}${process.env.REACT_APP_PORT}/registedusers`
      )
      .then((res) => {
        if (res.data !== "Fail" && res.data !== "Error") {
          setUsers(res.data);
        }
      })
      .catch((error) => {
        console.error("Sales: request failed:", error);
      });
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [pageSize]);

  // Combine sales data with buyer details (name, email, phone)
  const combinedSalesData = salesProducts.map((sale) => {
    const buyer = users.find((user) => user.user_id === sale.buyer_id);

    const sellers = users.find((user) => user.user_id === sale.seller_id);

    return {
      ...sale,
      buyer_name: buyer
        ? `${buyer.firstname} ${buyer.lastname}`
        : `${sale.customer_first_name} ${sale.customer_last_name}`,
      buyer_email: buyer ? buyer.email : sale.customer_email,
      buyer_phone: buyer ? buyer.phone : sale.customer_phone,
      sellerName:
        sellers && sellers.shopname
          ? sellers.shopname
          : sellers
          ? `${sellers.firstname} ${sellers.lastname}`
          : "Unknown Seller",
    };
  });

  // Get unique sellers for the dropdown options (display shopname or firstname lastname)
  const sellers = [
    "All Sales", // Add "All Sales" as the first option
    ...new Set(combinedSalesData.map((sale) => sale.sellerName)),
  ];

  // Map sellers to options for the Select component
  const stateOptions = sellers.map((seller) => ({
    value: seller,
    label: seller,
  }));

  // Initialize selectedSeller to "All Sales" by default

  const handleChange = (selectedOption) => {
    setSelectedSeller(selectedOption.value); // Set selected seller when an option is chosen
  };

  // Filter sales data based on selected seller
  const filteredSalesData =
    selectedSeller === "All Sales"
      ? combinedSalesData
      : combinedSalesData.filter((sale) => sale.sellerName === selectedSeller);

  // Start Pagination
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const tableData = filteredSalesData.slice(startIndex, endIndex);

  return (
    <div className="">
      <Adminnavbar />
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}

      <div className="container">
        <div className="fullscreen2">
          <main>
            <div className="text-center p-3">
              <h6>
                <i>
                  <span
                    className=""
                    style={{ color: "blue", fontSize: "25px" }}
                  >
                    Admin
                  </span>
                </i>{" "}
                Dashboard
              </h6>
            </div>

            <div className="m-2 ps-md-4 d-md-flex justify-content-between me-5">
              <h1 style={{ fontSize: "28px" }}>Sales</h1>
              <h1 style={{ fontSize: "28px" }}>
                Total Sales: {filteredSalesData.length}
              </h1>
            </div>

            <div className=" m-md-3 rounded">
              <div className="table-responsive p-md-3">
                {/* Dropdown to choose seller */}
                {/* <div className="mb-3 d-md-flex justify-content-end">
                  <div className="d-md-flex gap-2">
                  <label
                    htmlFor="viewOption"
                    className="form-label"
                    style={{ fontWeight: "500" ,marginTop:'5px'}}
                  >
                    Filter By:
                  </label>
                  <select
                    id="viewOption"
                    className="form-select"
                    style={{width:"280px"}}
                    value={selectedSeller}
                    onChange={(e) => setSelectedSeller(e.target.value)}
                  >
                    <option value="All Sales">All Sales</option>
                    {sellers.map((seller, index) => (
                      <option key={index} value={seller}>
                        {seller}
                      </option>
                    ))}
                  </select>
                  </div>
                </div> */}
                <div className="mb-3 d-md-flex justify-content-end">
                  <div className="d-md-flex gap-2">
                    <label
                      htmlFor="viewOption"
                      className="form-label"
                      style={{ fontWeight: "500", marginTop: "5px" }}
                    >
                      Filter By:
                    </label>

                    {/* Use the react-select component */}
                    <Select
                      options={stateOptions}
                      value={stateOptions.find(
                        (option) => option.value === selectedSeller
                      )}
                      onChange={handleChange}
                      placeholder="All Sales"
                      required
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: "280px",
                          borderRadius: "4px",
                          borderColor: "#ccc",
                          padding: "5px",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          width: "280px",
                          zIndex: "9999",
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          padding: "10px",
                          backgroundColor: state.isSelected
                            ? "transparent"
                            : provided.backgroundColor, // Keep the background transparent for selected options
                          color: state.isSelected ? "#007bff" : provided.color, // Option text color when selected
                          cursor: "pointer", // Indicate the option is clickable
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          // color: "#6c757d",
                        }),
                      }}
                    />
                  </div>
                </div>
                {/* Dropdown to choose seller */}
                {/* <div className="mb-3">
  <label htmlFor="viewOption" className="form-label">
    View Sales By:
  </label>
  <select
    id="viewOption"
    className="form-select w-25 float-end"
    value={selectedSeller}
    onChange={(e) => setSelectedSeller(e.target.value)}
  >
    <option value="All Sales">All Sales</option>
    {users.map((user, index) => (
      <option key={index} value={user.shopname || `${user.firstname} ${user.lastname}`}>
        {user.shopname || `${user.firstname} ${user.lastname}`}
      </option>
    ))}
  </select>
</div> */}
                <table
                  id="dynamic-table"
                  className="table table-striped table-bordered table-hover"
                  role="grid"
                  aria-describedby="dynamic-table_info"
                >
                  <thead>
                    <tr role="row">
                      <th className="p-3">Product Id</th>
                      <th className="sorting p-3" tabIndex="0">
                        Product Image
                      </th>
                      <th className="sorting p-3" tabIndex="0">
                        Product Name
                      </th>
                      <th className="hidden-480 sorting p-3" tabIndex="0">
                        Buyer Name
                      </th>
                      <th className="hidden-480 sorting p-3" tabIndex="0">
                        Order Price
                      </th>
                      <th className="hidden-480 sorting p-3" tabIndex="0">
                        Order Date
                      </th>
                      <th className="hidden-480 sorting p-3" tabIndex="0">
                        Shipment Date
                      </th>
                      <th className="hidden-480 sorting p-3" tabIndex="0">
                        Delivered Date
                      </th>
                      <th className="hidden-480 sorting p-3">
                        Contact Details
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.length > 0 ? (
                      tableData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.product_id}</td>
                          <td>
                            <div
                              className="text-center"
                              style={{ width: "100px", height: "100px" }}
                            >
                              <img
                                src={`${firstImage(item.image)}`}
                                alt="product"
                                style={{
                                  maxWidth: "100%",
                                  height: "100px",
                                  objectFit: "contain",
                                }}
                              />
                            </div>
                          </td>
                          <td>{item.name}</td>
                          <td>{item.buyer_name}</td>

                          <td>
                            {item.currency === "INR" ? (
                              <>
                                &#8377;{" "}
                                {item.order_amount}{" "}
                                {/* {parseFloat(item.order_amount).toFixed(2)}{" "} */}
                                {/* INR */}
                              </>
                            ) : (
                              <>
                                &#36; {formatPrice(item.order_amount, "USD")}{" "}
                                {/* &#36; {parseFloat(item.order_amount).toFixed(2)}{" "} */}
                                {/* USD */}
                              </>
                            )}
                          </td>
                          <td>
                            {item.ordered_date &&
                              item.ordered_date.slice(0, 10)}
                          </td>
                          <td>
                            {item.shipped_date &&
                              item.shipped_date.slice(0, 10)}
                          </td>
                          <td>
                            {item.delivered_date &&
                              item.delivered_date.slice(0, 10)}
                          </td>
                          <td>
                            {item.buyer_email} <br />
                            {item.buyer_phone}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={9} className="text-center">
                          No Data To Display
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <Adminpagination
                stateData={salesProducts}
                setViewRowIndex={setViewRowIndex}
                pageSize={pageSize}
                setPageSize={setPageSize}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            </div>
          </main>
        </div>
      </div>

      <Footer />
      <Scrolltotopbtn />
    </div>
  );
}